import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { statusQuerySchema } from '@/_schemas/status-input';

import { industryQueryBaseSchema } from './industry-query-base-schema';

export const industryQuerySchema = z.object({
  ...industryQueryBaseSchema.shape,
  parent_id: z.number().nullable(),
  status: statusQuerySchema,
  consumer_label: z.string().nullable(),
  description: z.string().nullable(),
  clients_count: z.number(),
  parent: industryQueryBaseSchema.nullish(),
  children: z.array(industryQueryBaseSchema).nullish(),
});

export type IndustryQuerySchema = z.infer<typeof industryQuerySchema>;

export const industryQueryAllSchema = paginatedResponseSchema(industryQuerySchema);

export type IndustryQueryAllSchema = z.infer<typeof industryQueryAllSchema>;
